var _g, _g2, _g3, _g4, _defs;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgBackpic1 = function SvgBackpic1(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 125,
    height: 54,
    viewBox: "0 0 125 54",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_32741_39547)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.37004 45.7175C2.9035 45.5745 3.22009 45.0262 3.07715 44.4927C2.9342 43.9593 2.38587 43.6427 1.8524 43.7856C1.31893 43.9286 1.00235 44.4769 1.14529 45.0104C1.28824 45.5438 1.83657 45.8604 2.37004 45.7175Z",
    stroke: "#227EFF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-17.7435 32.4719L-14.3628 31.5661C-14.3628 31.5661 -13.4907 33.2253 -12.9319 34.2885C-11.8153 36.4129 -10.2818 39.3306 -9.38207 41.0423C-8.94716 41.8698 -7.99795 42.2839 -7.09498 42.042L1.19933 39.8195C2.10479 39.5769 2.72021 38.7379 2.67977 37.8015L2.35144 30.1933",
    stroke: "#227EFF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.35143 30.1934L-12.6204 34.2051",
    stroke: "#227EFF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_32741_39547)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.0058 31.7599L45.1295 35.2955L39.0058 31.7599ZM39.803 25.0758C41.0538 29.7437 38.2837 34.5416 33.6158 35.7924C28.948 37.0431 24.1501 34.273 22.8993 29.6052C21.6486 24.9373 24.4187 20.1394 29.0865 18.8887C33.7543 17.6379 38.5523 20.408 39.803 25.0758Z",
    stroke: "#227EFF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_32741_39547)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M62.9275 20.5805L60.4965 11.5076L69.5694 9.07648L79.4301 14.7695C80.3377 15.2935 80.6487 16.4541 80.1247 17.3618L75.3805 25.579C74.8564 26.4866 73.6958 26.7976 72.7882 26.2736L62.9275 20.5805Z",
    stroke: "#227EFF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.4152 14.3473L65.3954 14.3359",
    stroke: "#227EFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3_32741_39547)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M99.2028 5.27721C99.0598 4.74374 99.3764 4.1954 99.9099 4.05246L117.297 -0.606283C117.83 -0.749228 118.378 -0.432637 118.521 0.100824L121.109 9.76008C121.252 10.2936 120.936 10.8419 120.402 10.9848L103.016 15.6436C102.482 15.7865 101.934 15.4699 101.791 14.9365L99.2028 5.27721Z",
    stroke: "#227EFF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.674 9.45056C111.741 9.16467 112.374 8.068 112.088 7.00107C111.802 5.93414 110.705 5.30097 109.639 5.58685C108.572 5.87274 107.938 6.96941 108.224 8.03634C108.51 9.10328 109.607 9.73644 110.674 9.45056Z",
    stroke: "#227EFF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.38 9.08291L104.361 9.07153",
    stroke: "#227EFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.971 5.9772L115.952 5.96582",
    stroke: "#227EFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_32741_39547"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(-20.4518 30.0918) rotate(-15)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_32741_39547"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(18.1852 19.739) rotate(-15)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_32741_39547"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(56.8222 9.38623) rotate(-15)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3_32741_39547"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(95.4592 -0.966553) rotate(-15)"
  })))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBackpic1, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/backpic1.5518a507.svg";
export { ForwardRef as ReactComponent };